import { Stack, Text, Title } from "@assetwatch/ui";

export function HomeScreen() {
  return (
    <Stack gap={24}>
      <Title size="md">Page content</Title>
      <Text tone="subtle">
        Frontend workspace generated from the AssetWatch app fieldops.
      </Text>
    </Stack>
  );
}
